import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabTemplate: 1,
};

export const tabTemplateSlice = createSlice({
  name: "tabTemplate",
  initialState,
  reducers: {
    changeTabTemplate: (state, action) => {
      state.tabTemplate = action.payload;
    },
  },
});

export const { changeTabTemplate } = tabTemplateSlice.actions;

export default tabTemplateSlice.reducer;
